let logoutHandler: (() => void) | null = null;

export function onUnauthorized(handler: () => void): () => void {
  logoutHandler = handler;
  return () => {
    logoutHandler = null;
  };
}

export function fireUnauthorized(): void {
  logoutHandler?.();
}
